import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=ff7fb1e2&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=ff7fb1e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7fb1e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff7fb1e2')) {
      api.createRecord('ff7fb1e2', component.options)
    } else {
      api.reload('ff7fb1e2', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=ff7fb1e2&scoped=true&", function () {
      api.rerender('ff7fb1e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2W11z5WKS4bCC/JS/teamMember.vue"
export default component.exports